import { extend } from 'flarum/common/extend';
import Post from 'flarum/common/models/Post';
import Stream from 'flarum/common/utils/Stream';
import app from 'flarum/forum/app';
import CommentPost from 'flarum/forum/components/CommentPost';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import UserPage from 'flarum/forum/components/UserPage';
import { VnodeDOM } from 'mithril';
import AnswerStore from './answerStore';

export { default as extend } from './extend';

app.initializers.add('bigge-display-profile-meta', () => {
  // User.prototype.masqueradeAnswers = Model.hasMany('masqueradeAnswers');

  // Get rid of the UserCard component
  // Object.assign(UserCard.prototype, {
  //   view() {
  //     return null; // Render nothing
  //   },
  // });

  extend(CommentPost.prototype, ['oncreate', 'onupdate'], async function (this: CommentPost, foo: void, vnode: VnodeDOM) {
    const post = this.attrs.post as Post;
    const user = post.user();
    const answerStore = new AnswerStore();

    if (!user) return;

    await answerStore.load(user);

    // const fullName = answerStore.getAnswer('Full Name');
    const jobTitle = answerStore.getAnswer('Job Title');
    const company = answerStore.getAnswer('Company/Org');

    let credentials = '';

    if (jobTitle) {
      credentials += jobTitle;
    }

    if (company) {
      if (jobTitle) {
        credentials += ' @ ';
      }

      credentials += company;
    }

    // if (fullName) {
    //   const usernameElement = vnode.dom.querySelector('.PostUser .username');
    //   if (usernameElement) {
    //     usernameElement.textContent = fullName;
    //   }
    // }

    const userNameContainer = vnode.dom.querySelector('.PostUser-name a');
    if (userNameContainer && !userNameContainer.querySelector('.PostUser-signature')) {
      const nameContainer = document.createElement('div');
      const username = userNameContainer.querySelector('.username');
      const signature = document.createElement('span');
      signature.className = 'PostUser-signature';
      signature.textContent = credentials;

      nameContainer.appendChild(username);
      nameContainer.appendChild(signature);
      userNameContainer.appendChild(nameContainer);
    }
  });

  // extend(DiscussionListItem.prototype, 'view', async function (view) {
  //   const discussion = this.attrs.discussion as Discussion;
  //   const lastPostedUser = discussion.lastPostedUser();
  //   const answerStore = new AnswerStore();

  //   if (!lastPostedUser) return;

  //   await answerStore.load(lastPostedUser);

  //   const fullName = answerStore.getAnswer('Full Name');

  //   if (fullName) {
  //     const usernameElement = view.dom.querySelector('.item-terminalPost .username');
  //     if (usernameElement) {
  //       usernameElement.textContent = fullName;
  //     }
  //   }
  // });

  extend(UserPage.prototype, ['oncreate'], async function (this: UserPage, foo: void, vnode: VnodeDOM) {
    const identityCard = vnode.dom.querySelector('.UserCard-identity');
    const answerStore = new AnswerStore();

    if (identityCard) {
      await answerStore.load(this.user);

      // const fullName = answerStore.getAnswer('Full Name');
      const jobTitle = answerStore.getAnswer('Job Title');
      const company = answerStore.getAnswer('Company/Org');

      // Update the username
      // const usernameElement = identityCard.querySelector('.username');
      // if (usernameElement) {
      //   usernameElement.textContent = fullName || usernameElement.textContent;
      // }

      // Clear any previous appended elements to avoid duplication
      const existingJobTitle = identityCard.querySelector('.UserCard-identity-jobTitle');
      const existingCompany = identityCard.querySelector('.UserCard-identity-company');
      if (existingJobTitle) existingJobTitle.remove();
      if (existingCompany) existingCompany.remove();

      // Append title and company
      const titleEl = document.createElement('span');
      const companyEl = document.createElement('span');
      titleEl.className = 'UserCard-identity-jobTitle';
      titleEl.textContent = jobTitle;
      companyEl.className = 'UserCard-identity-company';
      companyEl.textContent = company;

      identityCard.appendChild(titleEl);
      identityCard.appendChild(companyEl);

      // Move badges
      const badges = vnode.dom.querySelector('.UserCard-badges');
      const info = vnode.dom.querySelector('.UserCard-info');
      if (badges && info) {
        const badgesContainer = document.createElement('li');
        badgesContainer.appendChild(badges);
        info.insertBefore(badgesContainer, info.firstChild);
      }
    }
  });

  // Define required masquerade fields
  extend(SignUpModal.prototype, 'oninit', function () {
    this.fullName = Stream('');
    this.jobTitle = Stream('');
    this.company = Stream('');
  });

  // Add masquerade fields to the sign up modal
  extend(SignUpModal.prototype, 'fields', function (fields: any) {
    fields.add(
      'fullName',
      m('div', { class: 'Form-group' }, [
        m('input', {
          type: 'text',
          name: 'fullName',
          class: 'FormControl',
          placeholder: 'Full Name',
          autocomplete: 'name',
          bidi: this.fullName,
        }),
      ])
    );

    fields.add(
      'jobTitle',
      m('div', { class: 'Form-group' }, [
        m('input', {
          type: 'text',
          name: 'jobTitle',
          class: 'FormControl',
          placeholder: 'Job Title',
          autocomplete: 'organization-title',
          bidi: this.jobTitle,
        }),
      ])
    );

    fields.add(
      'company',
      m('div', { class: 'Form-group' }, [
        m('input', {
          type: 'text',
          name: 'company',
          class: 'FormControl',
          placeholder: 'Company/Organization',
          autocomplete: 'organization',
          bidi: this.company,
        }),
      ])
    );
  });

  // Add masquerade data to the sign up payload
  extend(SignUpModal.prototype, 'submitData', function (data: Record<string, any>) {
    data.fullName = this.fullName();
    data.jobTitle = this.jobTitle();
    data.company = this.company();

    return data;
  });

  extend(DiscussionListItem.prototype, 'view', function (vdom) {
    const discussion = this.attrs.discussion;
    const user = discussion.user();

    if (!user) return;

    // .DiscussionListItem-content
    const contentDiv = vdom.children?.find(child =>
        child?.attrs?.className?.includes('DiscussionListItem-content')
    );

    if (!contentDiv || !Array.isArray(contentDiv.children)) return;

    // .DiscussionListItem-main
    const mainDiv = contentDiv.children.find(child =>
        child?.attrs?.className?.includes('DiscussionListItem-main')
    );

    if (!mainDiv || !Array.isArray(mainDiv.children)) return;

    // <h2 class="DiscussionListItem-title">
    const titleHeading = mainDiv.children.find(child =>
        child?.tag === 'h2' && child?.attrs?.className === 'DiscussionListItem-title'
    );

    if (!titleHeading) return;

    // Ensure children array exists before modifying it
    if (!Array.isArray(titleHeading.children)) {
        titleHeading.children = [];
    }

    titleHeading.children.push(
        m('span', {
            className: 'DiscussionListItem-posterName',
        }, `By ${user.displayName()}`)
    );
});

  // Revise the profile completion alert
  app.translator.translations['fof-masquerade.forum.alerts.profile-completion-required'] =
    'Please complete all required fields in your profile before continuing.';
});
